export default "__VITE_ASSET__mp3dMWXi__"